import { TrendingDataPayload } from "../../../../../../legacy/types/companySearch/MI";

type ProductBreakdown = TrendingDataPayload["marketTimeSeriesProductBreakdown"];

const TOTAL_TOP_PRODUCTS = 10;

const getTopProducts = (productBreakdown: ProductBreakdown) => {
  const productHits = {} as Record<number, number>;

  for (const product of productBreakdown) {
    // Only process products with valid hits
    if (product.hits > 0 && Number.isFinite(product.hits)) {
      if (productHits[product.productId] !== undefined) {
        productHits[product.productId] += product.hits;
      } else {
        productHits[product.productId] = product.hits;
      }
    }
  }

  return Object.entries(productHits)
    .sort(([, hitsA], [, hitsB]) => hitsB - hitsA)
    .slice(0, TOTAL_TOP_PRODUCTS);
};

export const getChartData = (
  productBreakdown: ProductBreakdown,
  productsNameMapById: Record<number, string>
) => {
  const topProducts = getTopProducts(productBreakdown);

  return topProducts
    .filter(([, hits]) => hits > 0 && Number.isFinite(hits))
    .map((product) => ({
      productName: productsNameMapById[Number(product[0])] || "Unknown",
      hits: product[1],
    }));
};
